
const digest = '67e5965e0712745c6522ce99493c6fd3a222b6724c6624fc6951811501e3de82';
const classes = {"wrapper":"_wrapper_o56vi_1"};
const css = `._wrapper_o56vi_1 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  background-color: #ffffff;
  border: 1px solid #eaedf4;
  padding: 0 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  